/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { union } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import {
  byKeys,
  filterBy,
} from '@linc-technologies/linced-common/utils/arrays';
import type TrackingEvent from 'linced-app/models/notifications/tracking-event';

// Proto: notifications.TrackingInformation.
export default class TrackingInfo extends Fragment {
  declare [Type]: 'notifications/tracking-info';

  // Total number of clicks on links in email
  @attr('number', { defaultValue: 0 })
  declare totalClicks: number;

  // Info on clicks on links in email
  @fragmentArray('notifications/tracking-event')
  declare clicks: FragmentArray<TrackingEvent>;

  // Total number of times email has been opened
  @attr('number', { defaultValue: 0 })
  declare totalOpens: number;

  // Info on times email has been opened
  @fragmentArray('notifications/tracking-event')
  declare opens: FragmentArray<TrackingEvent>;

  // Info on times email has been opened and clicks on links in email
  @union('clicks', 'opens')
  declare clicksAndOpens: TrackingEvent[];

  // Find the earliest email click or email open timestamp
  @computed('clicksAndOpens.[]')
  get trackingTimeUnix() {
    if (this.clicksAndOpens) {
      return (
        filterBy(this.clicksAndOpens, 'timestamp').sort(byKeys('timestamp'))[0]
          ?.timestamp ?? null
      );
    }
    return null;
  }
}
